module.exports = __webpack_public_path__ + "static/media/pencil.89924262.png";